import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalEditorBreadcrumbs: ExperimentalQueries['experimentalEditorBreadcrumbs'] = (
	_,
	{ contentId },
	{ network },
) => {
	if (!contentId) {
		return Promise.reject(new Error('contentId is missing.'));
	}

	return fetchJSON(network, `/wiki/pages/breadcrumb.action?pageId=${contentId}`, {
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then((json) => ({
		breadcrumbs: json?.breadcrumbs,
		__typename: 'ExperimentalEditorBreadcrumbs',
	}));
};
